export default __webpack_public_path__ + "static/media/image-gallery-milkbottles.df1d9d84.jpg";